/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './MoneyInput.scss'
import React from 'react'
import { TextInput } from '../atoms'

function trim(value) {
  if (typeof value === 'string') {
    return value.replace(/,/g, '')
  }

  return value
}

export default function MoneyInput(props) {
  const value = props.value != null ? trim(props.value) : ''
  const isValid = value ? /^[-]?\d+$/.test(value) : true

  return (
    <TextInput
      className="MoneyInput"
      type="text"
      value={value.toString()}
      name={props.name}
      label={props.label || ''}
      onChange={props.onChange}
      onKeyUp={props.onChange}
      placeholder={props.placeholder}
      state={isValid ? '' : 'error'}
      disabled={props.disabled}
    />
  )
}
